import type { TreeOccurrence } from "../../shared/api/documentTreeTypes";

export function indexTreeOccurrences(occurrences: readonly TreeOccurrence[]) {
  const result = new Map<string | null, TreeOccurrence[]>();
  for (const item of occurrences) {
    const siblings = result.get(item.parent_id) ?? [];
    siblings.push(item);
    result.set(item.parent_id, siblings);
  }
  return result;
}
